<template>
  <session class="page-header" :class="{ block: scrollTop > 10 }">
    <div class="container header-container">
      <div class="logo"><span>本色数印｜PaperWonder</span></div>
      <div class="navs">
        <span @click="smoothScrollTo('#aboutus')">关于我们</span>
        <span @click="smoothScrollTo('#intro')">功能介绍</span>
<!--        <span @click="smoothScrollTo('#download')">下载APP</span>-->
      </div>
    </div>
  </session>
  <session class="page-container">
    <slot></slot>
  </session>
  <session class="page-footer">
    <div class="container">
      <div class="footer-container">
        <div class="footer-item"><a href="/protocol/term" _target="blank">用户协议</a>&<a href="/protocol/private" _target="blank">隐私协议</a></div>
        <div class="footer-item"><span>厦门市本色图文制作有限公司 | 福建省厦门市思明区文屏路1号嘉禾良库 | 联系我们paperwonder@126.com</span></div>
        <div class="footer-item"><span>Copyright © PaperWonder</span><a href="https://beian.miit.gov.cn/" _target="blank">闽ICP备12022680号</a></div>
      </div>
    </div>
  </session>
</template>

<script setup>
  import { onMounted, ref } from 'vue';

  const scrollTop = ref(0)
  onMounted(() => {
    window.addEventListener('scroll', function () {
      scrollTop.value = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
    })
  })

  const smoothScrollTo = (target) => {  
    const targetPosition = document.querySelector(target).getBoundingClientRect().top + window.pageYOffset;  
    window.scrollTo({  
      top: targetPosition,  
      behavior: "smooth"  
    });  
  } 
</script>

<style scoped lang="less">
@import "index.less";
</style>
